import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37eae54a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "fs-6 fw-bold" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body fs-5" }
const _hoisted_7 = { class: "d-flex gap-5" }
const _hoisted_8 = { class: "fw-bold uppercase" }
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import { ref, onMounted } from "vue";
import { TenantTypes } from "@/core/types/TenantTypes";
import { getCurrentInstance } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DevicesAndUsers',
  setup(__props) {

const { proxy } = getCurrentInstance();
const isLoading = ref(false);
const data = ref<any>([]);
const totalUsers = ref(0);
const tenantId = ref<any>(null);

var siteColors = {
  au: "#7a9e7a",
  bvi: "#fa6b6c",
  sea: "#349beb",
  mn: "#b497b4",
  jp: "#f6c23e",
};

const getSiteColor = (site: any) => {
  return siteColors[TenantTypes[site]] || "#000000"; // default color if site not found
};

const fecthData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryOnlineUsers();
    data.value = res.filter((item: any) => {
      return item.tenantId != TenantTypes.jp;
    });

    totalUsers.value = res.reduce((acc: number, item: any) => {
      if (item.tenantId == tenantId.value || proxy.$can("SuperAdmin")) {
        return acc + item.total;
      } else {
        return acc;
      }
    }, 0);
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

onMounted(() => {
  tenantId.value = localStorage.getItem("tenant");
  fecthData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("fields.totalUsers")) + ": " + _toDisplayString(totalUsers.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "success",
          onClick: fecthData,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (_ctx.$can('SuperAdmin') || tenantId.value == item.tenantId)
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  style: _normalizeStyle({ borderTop: `2px solid ${getSiteColor(item.tenantId)}` })
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.tenantName) + " " + _toDisplayString(_unref(TenantTypes)[item.tenantId]) + " - " + _toDisplayString(_ctx.$t("fields.totalUsers")) + ": " + _toDisplayString(item.total), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      class: "fs-6 fw-bold",
                      style: _normalizeStyle({ color: `${getSiteColor(item.tenantId)}` })
                    }, _toDisplayString(_ctx.$t("fields.browsers")), 5),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.clientStat, (client, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(i) + " : " + _toDisplayString(client), 1)
                      ]))
                    }), 128)),
                    _hoisted_10,
                    _createElementVNode("p", {
                      class: "fs-6 fw-bold",
                      style: _normalizeStyle({ color: `${getSiteColor(item.tenantId)}` })
                    }, _toDisplayString(_ctx.$t("fields.devices")), 5),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.deviceStat, (device, j) => {
                      return (_openBlock(), _createElementBlock("div", { key: j }, [
                        _createElementVNode("div", null, _toDisplayString(j) + " : " + _toDisplayString(device), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["style"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])), [
      [_directive_loading, isLoading.value]
    ])
  ]))
}
}

})